// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"7315d8f6","105":"7315d8f6","137":"5cec2fba","182":"7315d8f6","494":"7315d8f6","633":"7315d8f6"}[chunkId] + ".chunk.css";
};